// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__uFoy_","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1D4il"};